import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../image/Image';
import ProductTab from './ProductTab';
import axios from 'axios';

const baseURL = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';

const AdminPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('adminToken'));
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const memberIds = ['oleksandra', 'kristina', 'yurii', 'polina'];
  const initialImages = {
    oleksandra: Image.image1,
    kristina: Image.image2,
    yurii: Image.image3,
    polina: Image.image4,
  };

  const handleImageUpdate = (memberId, newImage) => {
    console.log(`Оновлено зображення для ${memberId}: ${newImage}`);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${baseURL}/api/admin/login`, { login, password });
      if (response.data.success) {
        localStorage.setItem('adminToken', response.data.token);
        setIsAuthenticated(true);
        setError('');
      } else {
        setError('Невірний логін або пароль');
      }
    } catch (err) {
      console.error('Помилка авторизації:', err);
      setError('Помилка сервера. Спробуйте ще раз.');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    setIsAuthenticated(false);
    navigate('/');
  };

  return (
    <div className="content_container">
      <div className="container">
        {!isAuthenticated ? (
          <div className="login-form-admin">
            <div className="login_container">
              <h2>Вхід в адмін-панель</h2>
              <form onSubmit={handleLogin}>
                <div>
                  <label>Логін:</label>
                  <input
                    type="text"
                    value={login}
                    onChange={(e) => setLogin(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label>Пароль:</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <button type="submit">Увійти</button>
              </form>
            </div>
          </div>
        ) : (
          <>
            <div className="top_panel-admin">
              <p>Адмін Панель</p>
              <button onClick={handleLogout} style={{ marginBottom: '20px' }}>Вийти</button>
            </div>
            <ProductTab />
          </>
        )}
      </div>
    </div>
  );
};

export default AdminPage;